<template>
  <div>
    <IncreaseFunds />
    <StaticExample />
    <BuildYourOwnRM />
    <Summary />
  </div>
</template>

<script>
import IncreaseFunds from '../IncreaseFunds.vue';
import StaticExample from '../StaticExample.vue';
import BuildYourOwnRM from './SavedBuildYourOwnRM.vue';
import Summary from '../../Summary/index.vue';

export default {
  components: { IncreaseFunds, StaticExample, BuildYourOwnRM, Summary }
};
</script>
